import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveCurrentPlanzoneRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveCurrentPlanzoneRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveCurrentPlanzoneRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getCurrentPlanzone() {
      return getState().planzone;
    },
  };
}

export { createSelector };
